const commissionAddSellRule = () =>
  import('@/views/main/commission/add/sell/sell.vue')
export default {
  path: '/main/commission/addSellRule',
  name: 'commissionAddSellRule',
  component: commissionAddSellRule,
  children: []
}
